import ProductFilter from "./product-filter"

export class NumberProductFilterModel extends ProductFilter {
  _minimumValue = 0
  _maximumValue = 0

  _allValuesEqual = true

  filterMinimum
  filterMaximum

  prefix = ""
  suffix = ""

  values = []
  stepSize

  constructor(group, products) {
    super(group, "NUMBER")

    this.prefix = group.prefix
    this.suffix = group.suffix
    this.stepSize = group.step_size || group.stepSize

    products.forEach((product) => {
      product.number_product_parameter_values.forEach((param) => {
        if (param.product_parameter_group.id !== this._id) return
        this.values.push(param.value)
      })
    })

    if (this.values && this.values.length > 0) {
      this._minimumValue = Math.min(...this.values)
      this._maximumValue = Math.max(...this.values)
    }

    this.filterMinimum = this._minimumValue
    this.filterMaximum = this._maximumValue

    this.updateValues(products)
  }

  setRangeMin(min) {
    this.filterMinimum = min || this._minimumValue
    this._updated(
      this.filterMinimum !== this._minimumValue ||
        this.filterMaximum !== this._maximumValue,
    )
  }

  setRangeMax(max) {
    this.filterMaximum = max || this._maximumValue
    this._updated(
      this.filterMinimum !== this._minimumValue ||
        this.filterMaximum !== this._maximumValue,
    )
  }

  reset() {
    this.filterMinimum = this._minimumValue
    this.filterMaximum = this._maximumValue
    super.reset()
  }

  compareProducts(p1, p2) {
    const aNumberValue = p1.getParamValues(this)[0]
    const bNumberValue = p2.getParamValues(this)[0]

    if (!aNumberValue) return -1
    if (!bNumberValue) return 1

    return aNumberValue.value - bNumberValue.value
  }

  hasEffectOn(product) {
    if (this.filterMinimum === this.filterMaximum) return false
    const index = product.number_product_parameter_values.findIndex(
      (param) => param.product_parameter_group.id === this._id,
    )

    return index !== -1
  }

  matches(product) {
    if (!this._isActive) {
      return true
    }

    const index = product.number_product_parameter_values.findIndex(
      (param) => param.product_parameter_group.id === this._id,
    )

    if (index === -1) {
      return false
    }

    const value = product.number_product_parameter_values[index].value

    return value >= this.filterMinimum && value <= this.filterMaximum
  }

  getState() {
    return {
      ...super.getState(),
      filterMinimum: this.filterMinimum,
      filterMaximum: this.filterMaximum,
    }
  }

  restoreState(state) {
    super.restoreState(state)
    this.filterMinimum = state.filterMinimum || this._minimumValue
    this.filterMaximum = state.filterMaximum || this._maximumValue
  }
}
